import styled from "@emotion/styled";
import {ReactComponent as svgGreenGraph} from "../../../../images/800CallLogs/Resources for Call Logs/GraphGreen.svg"

export const GraphGreenSvg = styled(svgGreenGraph)`
     width: 38px;
     height: 38px;
`;